import { IconProps } from '@/types/icon';

export function IconeEstrela(props: IconProps) {
  const { size, color, $fillColor, ...rest } = props;
  return (
    <svg
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      {...rest}
    >
      <path
        d="M11.75 1L14.84 7.26L21.75 8.27L16.75 13.14L17.93 20.02L11.75 16.77L5.57 20.02L6.75 13.14L1.75 8.27L8.66 7.26L11.75 1Z"
        stroke={color}
        fill={$fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
